"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pie = exports.Line = exports.HorizontalBar = exports.Doughnut = exports.Bar = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

function createChartInitializer() {
  var initialized = false;
  return /*#__PURE__*/function () {
    var _initializeChart = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _Chart$Legend, _yield$Promise$all, _yield$Promise$all2, chartModule, Chart;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (initialized) {
                _context.next = 9;
                break;
              }

              _context.next = 3;
              return Promise.all([import('chart.js'), // @ts-expect-error No types for chartjs plugins
              import('chartjs-plugin-crosshair'), import('chartjs-plugin-datalabels')]);

            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 1);
              chartModule = _yield$Promise$all2[0];
              Chart = chartModule.default || chartModule; // @ts-expect-error Legend doesn't exist in Chart types but it's available at runtime

              if ((_Chart$Legend = Chart.Legend) !== null && _Chart$Legend !== void 0 && _Chart$Legend.prototype) {
                // @ts-expect-error Legend doesn't exist in Chart types but it's available at runtime
                Chart.Legend.prototype.afterFit = function () {
                  if (this.height !== 0) {
                    this.height += 16;
                  }
                };
              }

              initialized = true;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function initializeChart() {
      return _initializeChart.apply(this, arguments);
    }

    return initializeChart;
  }();
}

var initializeChartOnce = createChartInitializer();
var Bar = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
  var _yield$import, Bar;

  return _regenerator.default.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return import('react-chartjs-2');

        case 2:
          _yield$import = _context2.sent;
          Bar = _yield$import.Bar;
          _context2.next = 6;
          return initializeChartOnce();

        case 6:
          return _context2.abrupt("return", {
            default: Bar
          });

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));
exports.Bar = Bar;
var Line = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
  var _yield$import2, Line;

  return _regenerator.default.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return import('react-chartjs-2');

        case 2:
          _yield$import2 = _context3.sent;
          Line = _yield$import2.Line;
          _context3.next = 6;
          return initializeChartOnce();

        case 6:
          return _context3.abrupt("return", {
            default: Line
          });

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
})));
exports.Line = Line;
var HorizontalBar = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
  var _yield$import3, HorizontalBar;

  return _regenerator.default.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return import('react-chartjs-2');

        case 2:
          _yield$import3 = _context4.sent;
          HorizontalBar = _yield$import3.HorizontalBar;
          _context4.next = 6;
          return initializeChartOnce();

        case 6:
          return _context4.abrupt("return", {
            default: HorizontalBar
          });

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
})));
exports.HorizontalBar = HorizontalBar;
var Doughnut = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
  var _yield$import4, Doughnut;

  return _regenerator.default.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return import('react-chartjs-2');

        case 2:
          _yield$import4 = _context5.sent;
          Doughnut = _yield$import4.Doughnut;
          _context5.next = 6;
          return initializeChartOnce();

        case 6:
          return _context5.abrupt("return", {
            default: Doughnut
          });

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5);
})));
exports.Doughnut = Doughnut;
var Pie = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
  var _yield$import5, Pie;

  return _regenerator.default.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return import('react-chartjs-2');

        case 2:
          _yield$import5 = _context6.sent;
          Pie = _yield$import5.Pie;
          _context6.next = 6;
          return initializeChartOnce();

        case 6:
          return _context6.abrupt("return", {
            default: Pie
          });

        case 7:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})));
exports.Pie = Pie;